import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { GridColumn, Button, Toastr, Utils, Loader } from "arv-reactcomponents";
import { SHOP_MULTILPE, Checkout } from "npmlinks-constants";
import { setLocalCart, getLocalCart } from "../../../utils";

@inject("LoginStore", "CheckoutStore", "MybagStore", "BrandStore", "CommonStore")
@observer
class AddToBagActions extends Component {
  static handleUnSelectedCase(isDesktop, noSkuIndex) {
    AddToBagActions.showToastr(
      SHOP_MULTILPE.SHOP_ALL_STYLES.SELECT_SIZE_TEXT,
      "notification",
    );
    const container = document.getElementsByClassName(
      (isDesktop && "nw-shopallstyles-productitemcontainer") ||
        "nw-shopallstyles-modalcontainer",
    )[0];
    const productElement = document.getElementsByClassName(
      `nw-productitem-container item-${noSkuIndex}`,
    )[0];
    Utils.scrollElemToTop(
      container,
      productElement,
      SHOP_MULTILPE.SHOP_ALL_STYLES.SCROLL_TIME,
    );
  }
  static showToastr(message, type, time) {
    Toastr.showToastr({
      className: `nwc-toastr-list-${type} nw-toastr`,
      message,
      timeout: time || 3000,
    });
  }
  constructor() {
    super();
    this.state = {
      loading: false,
    };
    this.onClick = this.onClick.bind(this);
    this.addToBag = this.addToBag.bind(this);
  }
  addToBag() {
    const { data } = this.props;
    const { isUserLoggedIn } = this.props.LoginStore;
    const validProducts = data.filter(
      item => item.selectedSku && item.isSelected,
    );
    if (validProducts.length === 0) {
      AddToBagActions.showToastr(
        SHOP_MULTILPE.SHOP_ALL_STYLES.ATLEAST_ONE_PRODUCT,
        "notification",
      );
      return null;
    }
    const existingCartItems = getLocalCart();
    const newCartItems = validProducts.map(item => {
      const newItem = item;
      const index = existingCartItems.findIndex(
        existingItem => existingItem.skuId === item.selectedSku.skuId,
      );
      if (index > -1) {
        newItem.selectedQty =
          (item.selectedQty || 1) + existingCartItems[index].qty;
      }
      return newItem;
    });
    this.setState({ loading: true });
    setLocalCart(newCartItems);
    const requestBody = Object.assign({}, Checkout.CHECKOUT_BASE_REQUEST);
    requestBody.type = Checkout.CHECKOUT_API_ACTIONS.READ;
    this.props.CheckoutStore.clearPresets();
    this.props.CheckoutStore.updateCart(
      requestBody,
      isUserLoggedIn,
      false,
      false,
      true,
    ).then(
      response => {
        const limitBreachedSkus =
          (response && response.limitBreachedSkus) || [];
        const limitBreached = limitBreachedSkus && limitBreachedSkus.length > 0;
        const message = limitBreached
          ? SHOP_MULTILPE.SHOP_ALL_STYLES.LIMIT_BREACH
          : SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_TO_BAG_SUCCESS;
        AddToBagActions.showToastr(
          message,
          "success",
          (limitBreached && 5000) || 3000,
        );
        this.props.MybagStore.getMyBagDetails(); // handling the paap of having mybag store and checkout store separate
        this.setState({ loading: false });
        this.props.closeModal();
      },
      () => {
        AddToBagActions.showToastr(
          SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_TO_BAG_ERROR,
          "danger",
        );
        this.setState({ loading: false });
      },
    );
    return null;
  }
  onClick() {
    const { data } = this.props;
    const { isDesktop } = this.props.CommonStore;
    if (this.state.loading) {
      AddToBagActions.showToastr(
        SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_WHILE_ADDING,
        "notification",
      );
      return null;
    }
    const noSkuIndex = data.findIndex(
      item => !item.selectedSku && item.isSelected,
    );
    if (noSkuIndex > -1) {
      AddToBagActions.handleUnSelectedCase(isDesktop, noSkuIndex);
      this.props.BrandStore.toggleProductsToBeSelected(true);
      setTimeout(() => {
        this.props.BrandStore.toggleProductsToBeSelected(false);
      }, 2000);
    } else {
      this.addToBag();
    }
    return null;
  }
  render() {
    const { loading } = this.state;
    return (
      <GridColumn className="nwc-grid-col-sm-5 nw-shopallstyles-actionsaddtocart">
        <Button
          className="nwc-btn-primary nw-shopallstyles-addtocartbtn"
          onClick={this.onClick}
        >
          {(loading && (
            <div className="nwc-translucentbackground-white nw-shopallstyles-addtocartbtnloader">
              <Loader />
            </div>
          )) ||
            null}
          {SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_TO_BAG_TEXT}
        </Button>
      </GridColumn>
    );
  }
}

AddToBagActions.wrappedComponent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.shape([]).isRequired,
  BrandStore: PropTypes.shape({
    toggleProductsToBeSelected: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    updateCart: PropTypes.func.isRequired,
    clearPresets: PropTypes.func.isRequired,
  }).isRequired,
  MybagStore: PropTypes.shape({
    getMyBagDetails: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddToBagActions.wrappedComponent,
  component: AddToBagActions,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/AddToBagActions/index.js